<template>
  <select
    :name="name"
    @input="updateValue">
    <option v-if="needsBlank" value=''>
      {{blankText}}
    </option>
    <template v-for="(option, index) in options">
      <option :key="index" :value="option.value" :selected="option.value == selectedValue">
        {{ option.label }}
      </option>
    </template>
  </select>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: false
    },
    selectedValue: {
    },
    needsBlank: {
      default: true
    },
    blankText: {
      type: String,
      default: "選択してください"
    }
  },
  methods: {
    updateValue: function(e) {
      this.$emit("input", e.target.value);
    }
  }
}
</script>